import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    login: false,
    token: "",
    user: "",
    login_time: "",
    home: true,
    role: "",
    center: "",
    centerId: ""
  },
  mutations: {
    _home(state) {
      state.home = false;
    },
    _login(state) {
      state.login = true;
    },
    _login_details(state, payload) {
      var keys = Object.keys(payload);
      keys.forEach(element => {
        state[element] = payload[element];
      });
      /* state.user = payload.user;
      state.login_time = payload.time;
      state.role = payload.role;
      state.token = payload.token;
      state.home = payload.home; */
    },
    _logout(state, payload) {
      console.log(state.user + " logged out!");
      var keys = Object.keys(payload);
      keys.forEach(element => {
        state[element] = payload[element];
      });
      /* 
      localStorage.removeItem("token");
      state.login = false;
      state.user = "";
      state.login_time = "";
      state.role = "";
      state.token = "";
      state.home = true; */
    }
  },
  getters: {
    get_home: function(state) {
      return state.home;
    },
    get_login: function(state) {
      return state.login;
    },
    get_login_details: function(state) {
      return {
        user: state.user,
        time: state.login_time,
        role: state.role,
        center: state.center,
        centerId: state.centerId
      };
    }
  },
  actions: {}
});
